module.exports = "./img/59477dc39dfa3ea480515e3c4e19a20f.png";